// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InfoCard_wrapper__3egPa"};